import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../../../../../shared/LanguageService';

const Header = styled('header')({
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderTopLeftRadius: '1px',
    borderTopRightRadius: '1px',
    padding: '16px'
});

const BoxForm = styled('form')({
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderBottomLeftRadius: '1px',
    borderBottomRightRadius: '1px',
    padding: '16px'
});

let SubmitButton = styled(Button)({
    width: 'fit-content'
});

type ArchivedOrderNoticeProps = {
    onSubmit?: () => void;
};

export function ArchivedOrderNotice({ onSubmit }: ArchivedOrderNoticeProps) {
    let isLoading = false;

    function handleSubmit(event: any) {
        event.preventDefault();
        if (onSubmit) {
            onSubmit();
        }
    }

    return (
        <Box component="section" aria-labelledby="approve-images-heading">
            <Header>
                <Typography variant="h2" sx={{ fontSize: '16px' }}>
                    {Translate('image-processing/page/panel-header/show-images')}
                </Typography>
            </Header>
            <BoxForm onSubmit={handleSubmit}>
                <Typography variant="body1" sx={{ fontSize: '14px' }}>
                    {Translate('image-processing/page/status-actions/header/show-images/text')}
                </Typography>
                <SubmitButton
                    type="submit"
                    variant="contained"
                    disabled={isLoading}
                    aria-busy={isLoading}
                    startIcon={isLoading ? <CircularProgress size={20} /> : undefined}
                >
                    {Translate('image-processing/page/status-actions/button-label/retrieve-images')}
                </SubmitButton>
            </BoxForm>
        </Box>
    );
}
